import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Section from '../base/Section';
import Card from '../base/Card';
import { Link } from 'react-router-dom';

export default function ServicesSection() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
    rootMargin: '50px',
  });

  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Vaciado de pisos y casas',
      description: 'Vaciado completo de viviendas, pisos y casas en Granollers. Retiramos todo tipo de enseres, muebles y objetos personales con total discreción y profesionalidad.',
      link: '/servicios#vaciado-pisos'
    },
    {
      icon: 'ri-store-2-line',
      title: 'Vaciado de locales comerciales',
      description: 'Servicio especializado en vaciado de locales, oficinas y espacios comerciales. Gestión integral de residuos y retirada de mobiliario profesional.',
      link: '/servicios#vaciado-locales'
    },
    {
      icon: 'ri-truck-line',
      title: 'Retirada de muebles y electrodomésticos',
      description: 'Recogida y transporte de muebles, electrodomésticos y enseres voluminosos. Servicio rápido con gestión responsable de residuos en Vallès Oriental.',
      link: '/servicios#retirada-muebles'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Limpieza por síndrome de Diógenes',
      description: 'Especialistas en limpieza extrema y casos de síndrome de Diógenes. Actuamos con máxima discreción, empatía y profesionalidad en situaciones delicadas.',
      link: '/servicios#limpieza-diogenes'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Pintura final',
      description: 'Servicio de pintura y acabados finales tras el vaciado. Dejamos el espacio listo para alquilar o vender con acabado profesional.',
      link: '/servicios#pintura'
    },
    {
      icon: 'ri-tools-line',
      title: 'Pequeñas reparaciones',
      description: 'Reparaciones menores, arreglos y mantenimiento básico. Solucionamos desperfectos para entregar el inmueble en perfectas condiciones.',
      link: '/servicios#reparaciones'
    },
  ];

  return (
    <Section background="light" padding="lg">
      <div className="text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-4">
          Nuestros servicios en Granollers
        </h2>
        <p className="text-lg text-tertiary max-w-3xl mx-auto">
          Ofrecemos soluciones completas de vaciado,{' '}
          <a 
            href="https://elprat.justclean.es/" 
            target="_blank" 
            rel="nofollow noopener noreferrer"
            className="text-primary hover:underline font-semibold cursor-pointer"
          >
            limpieza extrema y servicios complementarios en Granollers
          </a>
          , Canovelles, Les Franqueses del Vallès y toda la comarca del Vallès Oriental.
        </p>
      </div>

      <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map((service, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: index * 0.1, duration: 0.6 }}
            style={{ willChange: inView ? 'auto' : 'transform, opacity' }}
          >
            <Card hover className="h-full group cursor-pointer">
              <a href={service.link} className="block">
                <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-300">
                  <i className={`${service.icon} text-4xl text-primary`}></i>
                </div>
                <h3 className="text-xl font-bold text-secondary mb-3 group-hover:text-primary transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-tertiary leading-relaxed mb-4">
                  {service.description}
                </p>
                <div className="flex items-center text-primary font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span>Saber más</span>
                  <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center"></i>
                </div>
              </a>
            </Card>
          </motion.div>
        ))}
      </div>

      <div className="text-center mt-12">
        <Link 
          to="/servicios"
          className="inline-flex items-center gap-2 text-primary font-semibold text-lg hover:gap-4 transition-all duration-300 cursor-pointer"
        >
          Ver todos los servicios
          <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
        </Link>
      </div>
    </Section>
  );
}
